import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { CheckCircle, Error } from '@material-ui/icons'
import * as actions from '../actions'
import { MESSAGE } from '../constants'

const styles = theme => ({
  flashContainer: {
    position: 'fixed',
    top: '50px',
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)',
    [theme.breakpoints.down('xs')]: {
      top: '0',
      left: '0',
      transform: 'inherit',
      width: '100%',
    },
    fontSize: '16px',
    zIndex: '15000',
    padding: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'row',
    minWidth: '10%',
    minHeight: '40px',
    color: '#ffffff',
  },
  flashMessage: {
    flexGrow: '1',
    padding: '0 10px',
  },
  flashMessageHover: {
    '&:hover': {
      backgroundColor: '#00bcb5',
    },
  },
  flashSuccess: {
    backgroundColor: '#2fae54',
  },
  flashError: {
    backgroundColor: '#eb3d3d',
  },
  crossBtn: {
    cursor: 'pointer',
    userSelect: 'none',
    flexGrow: '0.1',
  },
  iconBox: {
    flexGrow: '0.1',
    height: '20px',
  },
  icon: {
    flexGrow: '0.1',
    height: '20px',
    fontSize: '20px',
  },
})

class FlashMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleClickCrossBtn = () => this.props.actions.hideFlashMessage()

  noob = () => {}

  getWrapperClickHandler = (msg, handler) => {
    switch (msg) {
      case MESSAGE.LOGIN_ERROR_MESSAGE:
        if (typeof handler === 'function') return handler
        return this.noob
      default:
        return this.noob
    }
  }

  checkMessageType = msg => {
    switch (msg) {
      case MESSAGE.LOGIN_ERROR_MESSAGE:
        return true
      default:
        return false
    }
  }

  render() {
    const { classes, message, isError, handleClick } = this.props
    return (
      message && (
        <div
          className={`${classes.flashContainer} ${this.checkMessageType(message) && classes.flashMessageHover} ${
            isError ? classes.flashError : classes.flashSuccess
          }`}>
          <div className={classes.iconBox}>{isError ? <Error className={classes.icon} /> : <CheckCircle className={classes.icon} />}</div>
          <div className={classes.flashMessage} onClick={this.getWrapperClickHandler(message, handleClick)} style={handleClick && { cursor: 'pointer' }}>
            {message
              .toString()
              .split(';')
              .map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
          </div>
          <div className={classes.crossBtn} name="button" type="button" onClick={this.handleClickCrossBtn}>
            x
          </div>
        </div>
      )
    )
  }
}

FlashMessage.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    message: state.common.message,
    isError: state.common.isError,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

const flashMessage = connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessage)

export default withStyles(styles)(flashMessage)



// WEBPACK FOOTER //
// ./src/components/FlashMessage.js